import { MutationType } from '@tencent/slide-sdk-pb-model';
import { assert } from 'ts-essentials';
import { BaseMutation } from '../../base/base-mutation';
import { Rule } from '../../base/mutation-rules';
import { DataType } from '../../../data';
import { invert } from '../../../utils/protoutil';
import type { IValidMutationData } from './../../../mutation/base';
import type { PresentationDataModel } from '../../../model/presentation-data-model';
import type { MaybeError } from '../../base/base-mutation';
import type { IValidSetDiagramDataMutationData } from '../../base/valid-mutation-data';

export class SetDiagramDataMutation extends BaseMutation<PresentationDataModel, IValidSetDiagramDataMutationData> {
    public readonly type: MutationType = MutationType.SetDiagramData;

    public apply(presentation: PresentationDataModel) {
        if (!this.data.shapeId) return;
        const { shapeId, dataModel } = this.data;
        const smartArt = presentation.store.models.get(shapeId, DataType.GraphicalObjectFrameSmartArt);
        assert(smartArt, 'shape should exist');
        if (!smartArt) return;
        smartArt.store.setDiagramData(dataModel);
    }

    public invert(presentation: PresentationDataModel): IValidMutationData[] {
        const { pageId, shapeId } = this.data;
        const smartArt = presentation.store.models.get(shapeId, DataType.GraphicalObjectFrameSmartArt);
        assert(smartArt, 'shape should exist');

        return [
            {
                type: MutationType.SetDiagramData,
                pageId,
                shapeId,
                ...invert(
                    { dataModel: smartArt.store.data.diagram?.dataModel },
                    { dataModel: this.data.dataModel },
                    { dataModel: true },
                ),
            },
        ];
    }

    public check(presentation: PresentationDataModel): MaybeError {
        const { pageId, shapeId } = this.data;
        return Rule.every(Rule.shape.should.existInPage(presentation, shapeId, pageId));
    }
}
